import types from '../mutation-types'
import decoder from '../../api/decoder'

const state = {
  decoders: {}
}

const mutations = {
  [types.SET_DECODERS] (state, data) {
    state.decoders = data
  }
}

const actions = {
  getDecoders ({commit}, data) {
    return decoder.index()
      .then((response) => {
        let data = response.data.data
        commit(types.SET_DECODERS, data)
        return response
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/decoder.js